// extracted by mini-css-extract-plugin
export default {"relatedCategories":"RelatedCategories-relatedCategories-iH5","categories":"RelatedCategories-categories-pKQ","category":"RelatedCategories-category-S2t"};